document.addEventListener("DOMContentLoaded", () => {
  // const klaviyoFormDiv = document.querySelector("[data-role='klaviyo-form']");
  // const skeletonLoaderDiv = document.querySelector(
  //   ".afex__content-skeleton-wrapper"
  // );

  // const observer = new MutationObserver((mutationsList) => {
  //   for (const mutation of mutationsList) {
  //     if (mutation.type === "childList") {
  //       const klaviyoForm = document.querySelector(
  //         "[data-role='klaviyo-form'] form"
  //       );
  //       if (klaviyoForm) {
  //         skeletonLoaderDiv.remove();
  //         observer.disconnect();
  //         break;
  //       }
  //     }
  //   }
  // });

  // observer.observe(klaviyoFormDiv, { childList: true, subtree: true });

  const progressCircle = document.querySelector(
    ".afex-swiper .autoplay-progress svg"
  );
  const progressContent = document.querySelector(
    ".afex-swiper .autoplay-progress span"
  );
  const swiperContainer = document.querySelector(".afex-swiper");
  const duration = Number(swiperContainer.dataset.slideDuration);
  const heroSwiper = new Swiper(swiperContainer, {
    autoplay: {
      delay: duration,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    loop: true,
    on: {
      autoplayTimeLeft(s, time, progress) {
        if(progressCircle) progressCircle.style.setProperty("--progress", 1 - progress);
        if(progressContent) progressContent.textContent = `${Math.ceil(time / 1000)}s`;
      },
    },
  });
});
